/**
 * @file 快速上手
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';

import PictureCardGroup from '../../../../components/picture-card/PictureCardGroup';
import quickOnhandData from './quickOnhandData';


const QuickOnhand: React.FC = () => {
    return (
        <PictureCardGroup
            className="paddle-quick-onhand"
            option={quickOnhandData}
        />
    );
};

export default QuickOnhand;
